import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, FileText } from "lucide-react";
import { adminApi, apiError } from "@/lib/api";

const prevMonth = () => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const ExportTab = () => {
  const [month, setMonth] = useState(prevMonth());
  const [busy, setBusy] = useState("");

  const download = async (format) => {
    setBusy(format);
    try {
      const { data } = await adminApi.get("/export", { params: { month, format }, responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ClimNova_ventes_${month}.${format}`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Export téléchargé");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy("");
    }
  };

  return (
    <div data-testid="export-tab" className="max-w-xl flex flex-col gap-5 rounded-2xl bg-white border border-slate-200 p-6">
      <div>
        <h2 className="font-display text-xl text-slate-900">Export comptable</h2>
        <p className="text-sm text-slate-500 mt-1">Ventes payées du mois (date de paiement, heure de Paris), remboursements et synthèse TVA 20 %.</p>
      </div>
      <label className="flex flex-col gap-1 text-sm font-medium text-slate-700 max-w-[12rem]">Mois
        <input type="month" data-testid="export-month-input" value={month} onChange={(e) => setMonth(e.target.value)} className="field-input" />
      </label>
      <div className="flex flex-wrap gap-3">
        <button type="button" disabled={!month || !!busy} onClick={() => download("xlsx")} data-testid="export-xlsx-button" className="btn-heat !py-2.5 disabled:opacity-50">
          <FileSpreadsheet className="w-4 h-4" /> {busy === "xlsx" ? "Génération…" : "Télécharger Excel (.xlsx)"}
        </button>
        <button type="button" disabled={!month || !!busy} onClick={() => download("csv")} data-testid="export-csv-button" className="btn-ghost-ice !py-2.5 disabled:opacity-50">
          <FileText className="w-4 h-4" /> {busy === "csv" ? "Génération…" : "Télécharger CSV"}
        </button>
      </div>
    </div>
  );
};
